import { BaseEntity, PaginatedEntity } from '@core/entities/_extra';
import { Expose, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';
import { InstructorType } from '@core/enums';
import { UserEntity } from '@core/entities/user.entity';
import { CourseBookingDetails, CourseEntity } from '@core/entities/course.entity';

export class InstructorsListEntity extends PaginatedEntity {
  @Type(() => InstructorEntity)
  instructors: InstructorEntity[];
}

export class InstructorEntity extends BaseEntity {
  @Expose({ name: 'first_name' })
  firstName = '';

  @Expose({ name: 'last_name' })
  lastName = '';

  @Expose({ name: 'add_img' })
  addImg = '';

  type: InstructorType;
  description = '';

  @Expose({ name: 'internal_id' })
  internalId = 0;

  @Expose({ name: 'emaill' })
  email = '';

  @Expose({ name: 'phone_no' })
  phoneNo = '';

  address = '';

  @Expose({ name: 'courses_type' })
  courseType = 0;

  author = 0;

  @Expose({ name: 'active_from' })
  activeFrom = '';

  @Expose({ name: 'active_to' })
  activeTo = '';

  @Type(() => InstructorTag)
  instructorTags: InstructorTag[] | string[];

  tags: string[] = [];

  @Expose({ name: 'availablity' })
  @Type(() => Availability)
  availability: Availability[];

  @Expose({ name: 'instructorBooking' })
  @Type(() => InstructorBooking)
  instructorBookings?: InstructorBooking[];

  @Expose({ name: 'instructorBookingDetails' })
  @Type(() => CourseBookingDetails)
  instructorBookingDetails?: CourseBookingDetails[];

  @Type(() => UserEntity)
  user: UserEntity;

  // For PUT/POST request
  weekdays = [{ day: '', time_from: '', time_to: '' }];

  /**
   * Qualification property
   * For GET request
   */
  @Type(() => Qualification)
  qualification: Qualification[];

  /**
   * Qualification property
   * For PUT/POST request
   */
  qualifications = [''];

  // For UI use only
  imageUrl: string | SafeUrl;

  constructor(init?: Partial<InstructorEntity>) {
    super(init);
    this.initEntity(init);
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export class InstructorTag {
  @Expose({ name: 'tag_name' })
  tagName: string;
  id: number;
  @Expose({ name: 'tag_id' })
  tagId: number;
}

export class Availability {
  id: number;

  @Expose({ name: 'instructor_id' })
  instructorId: number;

  weekday: string;

  @Expose({ name: 'time_from' })
  timeFrom: string;

  @Expose({ name: 'time_to' })
  timeTo: string;
}

export class Qualification {
  id: number;
  qualification: string;
}

export class InstructorBooking {
  id = 0;

  @Expose({ name: 'course_id' })
  courseId = 0;

  @Expose({ name: 'date_from' })
  dateFrom = '';

  @Expose({ name: 'start_time' })
  startTime = '';

  @Expose({ name: 'end_time' })
  endTime = '';

  @Expose({ name: 'course' })
  @Type(() => CourseEntity)
  course: CourseEntity;
}
